module.exports = __webpack_public_path__ + "static/img/content4.61ba53cd.png";